import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ArrowRightLeft, X } from "lucide-react";
import { api, errMsg } from "../lib/api";

const sel = "bg-muted/60 border h-9 px-2 text-sm";

const summary = (r) => {
  const n = (k) => r[k].owner + r[k].backup;
  return `Moved ${r.accounts} account(s), ${n("leads")} open lead(s) and ${n("uids")} open UID(s)${r.alerted ? " · new owner told by bell and email" : " · new owner has no login, so no alert"}`;
};

export const useAccountOwners = (on, tick) => {
  const [owners, setOwners] = useState([]);
  const [team, setTeam] = useState([]);
  useEffect(() => {
    if (!on) return;
    api.get("/admin/account-owners").then((r) => setOwners(r.data)).catch(() => {});
    api.get("/admin/sales-team").then((r) => setTeam(r.data.items.filter((x) => x.in_team).map((x) => x.name))).catch(() => {});
  }, [on, tick]);
  return { owners, team };
};

export const OwnerFilter = ({ owners, value, onChange }) => (
  <select data-testid="accounts-filter-owner" value={value} onChange={(e) => onChange(e.target.value)} className={sel}>
    <option value="">All owners</option>
    {owners.map((o) => <option key={o.name} value={o.name}>{o.name}{o.in_team ? "" : " (former)"} · {o.accounts}</option>)}
  </select>
);

export const TransferBar = ({ ids, team, onClear, onDone }) => {
  const [to, setTo] = useState("");
  const [busy, setBusy] = useState(false);
  if (!ids.length) return null;
  const go = () => {
    if (!window.confirm(`Transfer ${ids.length} account(s) to ${to}? Their open leads and UIDs owned (or backed up) by the old owner move too, and ${to} gets a bell alert and an email.`)) return;
    setBusy(true);
    api.post("/admin/accounts/transfer", { account_ids: ids, to }).then((r) => { toast.success(summary(r.data), { duration: 10000 }); setTo(""); onDone(); })
      .catch((e) => toast.error(errMsg(e))).finally(() => setBusy(false));
  };
  return (
    <div className="ax-panel p-3 mb-3 flex flex-wrap items-center gap-2 border-primary/50" data-testid="accounts-transfer-bar">
      <span className="text-sm font-medium" data-testid="accounts-selected-count">{ids.length} selected</span>
      <button data-testid="accounts-clear-selection" onClick={onClear} className="border h-8 px-2 text-xs flex items-center gap-1 hover:border-primary"><X className="h-3.5 w-3.5" />Clear</button>
      <span className="text-xs text-muted-foreground">Transfer to</span>
      <select data-testid="accounts-transfer-to" value={to} onChange={(e) => setTo(e.target.value)} className={`${sel} h-8 min-w-[160px]`}>
        <option value="">Pick a sales team member</option>{team.map((n) => <option key={n} value={n}>{n}</option>)}</select>
      <button data-testid="accounts-transfer-submit" disabled={!to || busy} onClick={go} className="bg-primary text-primary-foreground h-8 px-4 text-sm flex items-center gap-1.5 disabled:opacity-50">
        <ArrowRightLeft className="h-4 w-4" />{busy ? "Moving…" : "Transfer accounts"}</button>
      <span className="text-xs text-muted-foreground w-full sm:w-auto">Open leads and UIDs of these accounts move with them. Closed records keep the old name.</span>
    </div>
  );
};
